import { Component, OnInit, Input, ViewChild, OnChanges, SimpleChanges } from '@angular/core';
import { ProgramDto, ProgramFundingListItemDto, PlanData, RetailerLookupDto, StrategicBusinessInitiativeLookupDto, BrandLookupDto, BudgetYearLookupDto, SaveProgramCommand, ProgramId } from 'app/client-core/dtos/programs.model';
import { RetailerService } from 'app/client-core/services/retailer.service';
import { ProgramService } from 'app/client-core/services/program.service';
import { Observable } from 'rxjs';
import { ValidationMessage } from 'app/validation';
import { TypeaheadMatch } from 'ngx-bootstrap';
import { ApiResponse } from 'app/client-core/api-response-models';
import { Router } from '@angular/router';
import { BudgetYearTypeaheadComponent, StrategicBusinessInitiativesTypeaheadComponent, RetailersTypeaheadComponent } from '../typeahead';
import { BasicTypeaheadComponent } from '../typeahead/typeaheads/tactics/basic-typeahead.component';
import { CampaignThemeDto } from 'app/client-core/dtos/campaigns.model';
import { CampaignService } from 'app/client-core/services/campaign.service';
import { LayoutService } from '../layout/layout.service';
import { UserService } from 'app/client-core/services/user.service';
import { BrandService } from 'app/client-core/services/brand.service';
import { JobsToBeDoneModel } from 'app/client-core/dtos/jobs-to-be-done.model';
import { NotificationService } from '../utils/notification.service';
import { ContributionDto } from 'app/client-core/dtos/contribution.model';

@Component({
  selector: 'app-contributions',
  templateUrl: './contributions.component.html',
  styleUrls: ['./contributions.component.scss']
})
export class ContributionsComponent implements OnInit, OnChanges {
  ready: boolean;
  @Input() brandId?: number;
  @Input() budgetYear?: number;
  @Input() title: string;
  @ViewChild('brandsTypeahead') brandsTypeahead: BasicTypeaheadComponent

  contributionDtoList = new Array<ContributionDto>();
  submitting: boolean;
  submitted: boolean;
  sectors: Array<{ id: number, name: string }>
  validationMessages: ValidationMessage;
  search: string;
  contributionDtoListToShow = new Array<ContributionDto>();
  extraQueryParams: {};
  additionalColumns = [
    { prop: 'item.jobsToBeDoneHeaderId', name: 'Header Id', minWidth: 250 },
  ];
  selectedContribution: any;

  constructor(
    private layoutService: LayoutService,
    private brandService: BrandService,
    private notificationService: NotificationService,
  ) {
  }

  ngOnInit(): void {

  }

  ngOnChanges(changes: SimpleChanges): void {
    this.ready = false;
    this.search = "";
    this.extraQueryParams = {
      brandid: this.brandId,
      budgetYear: this.budgetYear
    }
    this.loadContributions();
  }

  clear() {

  }

  closeModal() {
    this.layoutService.hideSideModal.next();
  }

  loadContributions() {
    this.brandService.getContributions(this.budgetYear, this.brandId).subscribe(response => {
      this.ready = true;
      this.contributionDtoList = response.data;
      this.contributionDtoListToShow = response.data;
    })
  }

  onSubmit(): void {
    this.submitted = false;

    if (!this.canSubmit()) {
      this.submitted = true;
      this.validationMessages = new ValidationMessage(null, true, "There were some validation errors").isDanger();
      return;
    }
    this.brandService.saveContributions(this.brandId, this.contributionDtoList).subscribe(res => {
      if (!res.hasError) {
        this.validationMessages = new ValidationMessage(null, true, 'Contributions saved').isSuccess();
        this.closeModal();
      } else {
        this.validationMessages = new ValidationMessage(res.error, true, "Contributions could not be saved");
      }
    },
      (err: any) => {
        this.validationMessages = new ValidationMessage(null, true, "Unexpected error occured");
      },
      () => {
        this.submitting = false;
      });
  }

  calcTotalAtl() {
    let total = 0;
    this.contributionDtoList.forEach((item, index) => {
      if (item.atlPercent) {
        total += parseFloat(item.atlPercent.toString());
      }
    });
    if (total > 0) total = parseFloat(total.toFixed(2));
    return total;
  }

  calcTotalBtl() {
    let total = 0;
    this.contributionDtoList.forEach((item, index) => {
      if (item.btlPercent) {
        total += parseFloat(item.btlPercent.toString());
      }
    });
    if (total > 0) total = parseFloat(total.toFixed(2));
    return total;
  }

  canSubmit() {
    return true;
  }


  delete(item: ContributionDto) {
    if (item.canDelete != 'DELETE') {
      return;
    }
    this.notificationService.smartMessageBox({
      title: "Are you sure you want to delete this contribution?",
      content: "",
      buttons: '[No][Yes]'

    }, (ButtonPressed) => {
        if (ButtonPressed == "Yes") {
          this.brandService.deleteJobsToBeDoneBrands(item.contributingBrandId, item.jobsToBeDoneHeaderId).subscribe(res => {
            this.loadContributions();
            this.validationMessages = new ValidationMessage(null, true, `Contribution deleted`).isSuccess();
          });
        }
    });
    
  }

  updateAtl(contributionDto: ContributionDto) {
    this.contributionDtoList.find(c => c.id == contributionDto.id).atlPercent = contributionDto.atlPercent;
    if (contributionDto.btlEdit != "EDIT") {
      this.contributionDtoList.find(c => c.id == contributionDto.id).btlPercent = contributionDto.atlPercent;
    }
  }

  updateBtl(contributionDto: ContributionDto) {
    this.contributionDtoList.find(c => c.id == contributionDto.id).btlPercent = contributionDto.btlPercent;
    if (contributionDto.atlEdit != "EDIT") {
      this.contributionDtoList.find(c => c.id == contributionDto.id).atlPercent = contributionDto.btlPercent;
    }
  }

  filter() {
    if (!this.contributionDtoList || this.contributionDtoList.length == 0)
      return;

    this.contributionDtoListToShow = this.contributionDtoList.filter(c => c.brandName.toLocaleLowerCase().indexOf(this.search.toLocaleLowerCase()) > -1);
  }

  onContributionSelected(event) {
    this.selectedContribution = event.item;
  }

  addContribution() {
    this.brandService.saveContribution(this.selectedContribution.jobsToBeDoneHeaderId, this.selectedContribution.id).subscribe(response => {
      this.brandsTypeahead.clearText();
      this.loadContributions();
      this.validationMessages = new ValidationMessage(null, true, `Contribution Added`).isSuccess();
    })
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/contributions/contributions.component.ts